export default "__VITE_ASSET__CsbC40NZ__"